import { createContext } from "react";

export type AppVersionContextValues = {
  showDialog: boolean;
  handleDialogResponse: (response: boolean) => void;
  currentVersion: string;
};

export const AppVersionContext = createContext<AppVersionContextValues | null>(
  null,
);
